/**
 * Created by Ning Jiang on 2017-09-20.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {TeslaGameConfig} from "../game/TeslaGameConfig";

export class DebugInfo extends BaseView {
    private _layer:PIXI.Container;
    private _landscape:PIXI.Graphics;
    private _portrait:PIXI.Graphics;
    private _debugInfo:PIXI.Text;
    private _debugOverlay:ScalableLayer;
    private _showSafeZone:boolean;

    constructor(showSafeZone:boolean) {
        super();
        this._showSafeZone = showSafeZone;
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.DEBUG_BACKGROUND.name);
        this._debugOverlay = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.DEBUG_OVERLAY.name);

        const textStyle:TextStyleOptions = {
            fontFamily : "Open Sans",
            fontSize : 20,
            fill : "#FFFFFF"
        };

        this._debugInfo = new PIXI.Text("", textStyle);
        this._debugInfo.position.set(10, 10);

        this._landscape = DebugInfo.createDebugRegion(
            TeslaGameConfig.STAGE_WIDTH_LANDSCAPE,
            TeslaGameConfig.STAGE_HEIGHT_LANDSCAPE,
            1682,
            960
        );

        const landscapeSafeZone = new PIXI.Rectangle(0, 0, TeslaGameConfig.STAGE_WIDTH_LANDSCAPE, TeslaGameConfig.STAGE_HEIGHT_LANDSCAPE);
        this._landscape = DebugInfo.addSafeZone(this._landscape, landscapeSafeZone);

        this._portrait = DebugInfo.createDebugRegion(
            TeslaGameConfig.STAGE_WIDTH_PORTRAIT,
            TeslaGameConfig.STAGE_HEIGHT_PORTRAIT,
            960,
            1682
        );

        const portraitSafeZone = new PIXI.Rectangle(0, 0, 720, 1074);
        this._portrait = DebugInfo.addSafeZone(this._portrait, portraitSafeZone);

        if(GameSetting.isDevMode) {
            if(this._showSafeZone == true) {
                this._layer.addChild(this._portrait);
                this._layer.addChild(this._landscape);
            }
            this._debugOverlay.addChild(this._debugInfo);
        }
    }


    protected onResize(data:IResizeData):void {
        if(GameSetting.isDevMode) {
            if(this._showSafeZone == true) {
                if(data.orientation == Orientation.PORTRAIT) {
                    this._layer.addChild(this._portrait);
                    this._layer.removeChild(this._landscape);
                } else {
                    this._layer.addChild(this._landscape);
                    this._layer.removeChild(this._portrait);
                }
            }

            this.updateDebugInfo(data);

        }
    }

    private static createDebugRegion(stageWidth:number, stageHeight:number, bgWidth:number, bgHeight:number):PIXI.Graphics {
        let gfx:PIXI.Graphics = new PIXI.Graphics();
        gfx.beginFill(0xFF0000, 0.2);
        gfx.drawRect(
            (stageWidth - bgWidth) * 0.5,
            (stageHeight - bgHeight) * 0.5,
            bgWidth,
            bgHeight
        );
        gfx.endFill();
        return gfx;
    }

    private static addSafeZone(gfx:PIXI.Graphics, safeZone:PIXI.Rectangle):PIXI.Graphics {
        gfx.beginFill(0x00FF00, 0.2);
        gfx.drawRect(
            safeZone.x,
            safeZone.y,
            safeZone.width,
            safeZone.height
        );
        gfx.endFill();
        return gfx;
    }

    private updateDebugInfo(data:IResizeData) {
        this._debugInfo.text =
            "tl: " + data.top + ", " + data.left + "\n" +
            "br: " + data.bottom + ", " + data.right + "\n" +
            "size: " + data.width + "," + data.height + "\n" +
            "orien: " + data.orientation + "\n" +
            "aspect: " + (Math.max(data.width, data.height) / Math.min(data.width, data.height)).toFixed(4);
    }
}